export const columnsDataDevelopment = ["ID", "ID MESIN", "ID JOB", "PID", "IP ADDRESS", "DB", "ID USER", "STATE", "ACTIVITY"];
